import BugsnagPerformance from '@bugsnag/browser-performance';
import Bugsnag from '@bugsnag/js';
import { BugsnagNamedSpansPlugin } from '@bugsnag/plugin-named-spans';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React, { PropsWithChildren } from 'react';
import { BUG_SNAG_ENABLED, MODE, VITE_BUG_SNAG_API_KEY } from 'shared/config';
import { createComposableProvider } from 'shared/lib';

if (BUG_SNAG_ENABLED) {
	Bugsnag.start({
		apiKey: VITE_BUG_SNAG_API_KEY!,
		plugins: [new BugsnagPluginReact()],
		releaseStage: MODE,
	});

	BugsnagPerformance.start({
		apiKey: VITE_BUG_SNAG_API_KEY,
		plugins: [new BugsnagNamedSpansPlugin()],
		releaseStage: MODE,
	});
}

const ErrorBoundary = BUG_SNAG_ENABLED
	? (Bugsnag.getPlugin('react')?.createErrorBoundary(React) ?? React.Fragment)
	: React.Fragment;

export const BugSnagProvider = ({ children }: PropsWithChildren) => (
	<ErrorBoundary>{children}</ErrorBoundary>
);

export const withBugSnag = createComposableProvider(BugSnagProvider);
